import { query, where, orderBy } from 'firebase/firestore'
import type { Community } from '#shared/types/Community'
import type { TCommunityGroup } from '#shared/types/CommunityGroup'

export const useCommunityGroups = () => {
    const { $firebase } = useNuxtApp()

    const getCommunityGroup = async (
        communityId: Community['id'],
        groupSlug: TCommunityGroup['slug']
    ): Promise<TCommunityGroup> => {
        const collectionPath = `communities/${communityId}/community-groups`
        return await $firebase.loadFirstDocument<TCommunityGroup>(
            collectionPath,
            (ref) => query(ref, where('slug', '==', groupSlug))
        )
    }

    const getCommunityGroups = async (communityId: Community['id']): Promise<TCommunityGroup[]> => {
        const collectionPath = `communities/${communityId}/community-groups`
        return await $firebase.listDocuments<TCommunityGroup>(
            collectionPath,
            (ref) => query(ref, orderBy('order', 'desc'))
        )
    }

    return {
        getCommunityGroup,
        getCommunityGroups
    }
}
